import { ApplicationCveListWebComponent } from './component/ApplicationCveListWebComponent';

export { ApplicationCveListWebComponent };
